 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1DIRECTDAUGHTERCROSSINGMODE from '@/components/0_chapter1directdaughtercrossingmode'
 import A_CHAPTER2HOLDAGOODHANDOFCARDS from '@/components/1_chapter2holdagoodhandofcards'
 import A_CHAPTER3YETHEHADACTUALLYCAUSEDHIMSELFTOCOMMITSUICIDE from '@/components/2_chapter3yethehadactuallycausedhimselftocommitsuicide'
 import A_CHAPTER4MYRIADLOVECOLLECTION from '@/components/3_chapter4myriadlovecollection'
 import A_CHAPTER5COLLAPSEOFTHECONCEPTOFMARRIAGE from '@/components/4_chapter5collapseoftheconceptofmarriage'
 import A_CHAPTER6PRINCESSACCOMPANYINGREADING from '@/components/5_chapter6princessaccompanyingreading'
 import A_CHAPTER7ASTONESTIRSATHOUSANDRIPPLES from '@/components/6_chapter7astonestirsathousandripples'
 import A_CHAPTER8PREPARINGFORENTRYTOTHEPALACE from '@/components/7_chapter8preparingforentrytothepalace'
 import A_CHAPTER9OLDMASTERXUASKEDHIMTORETURNHOMEINADREAM from '@/components/8_chapter9oldmasterxuaskedhimtoreturnhomeinadream'
 import A_CHAPTER10LADYJIWANTSABUTLER1 from '@/components/9_chapter10ladyjiwantsabutler1'
 import A0_CHAPTER11LADYJIWANTSABUTLER2 from '@/components/10_chapter11ladyjiwantsabutler2'
 import A1_CHAPTER12XUMINGMEIAVOIDEDTHEMOONNESTING1 from '@/components/11_chapter12xumingmeiavoidedthemoonnesting1'
 import A2_CHAPTER13XUMINGMEIAVOIDEDTHEMOONNESTINGPARTII from '@/components/12_chapter13xumingmeiavoidedthemoonnestingpartii'
 import A3_CHAPTER14XUMINGLANMADEARUCKUSATTHEXUEJU1 from '@/components/13_chapter14xuminglanmadearuckusatthexueju1'
 import A4_CHAPTER15XUMINGLANCAUSEDAHUGERUCKUSINTHEXUEJUPARTII from '@/components/14_chapter15xuminglancausedahugeruckusinthexuejupartii'
 import A5_CHAPTER16AFIRSTCLASSGIRLISILLITERATE1 from '@/components/15_chapter16afirstclassgirlisilliterate1'
 import A6_CHAPTER17AGIRLOFFIRSTCLASSISILLITERATEPARTII from '@/components/16_chapter17agirloffirstclassisilliteratepartii'
 import A7_CHAPTER18LITTLEGARDENENCOUNTERWITHXUTIANDI from '@/components/17_chapter18littlegardenencounterwithxutiandi'
 import A8_CHAPTER19PEACHESAREMORETHANJUSTARICEBUCKET from '@/components/18_chapter19peachesaremorethanjustaricebucket'
 import A9_CHAPTER20MENFROMTHEPALACE1 from '@/components/19_chapter20menfromthepalace1'
 import A0_CHAPTER21MENFROMTHEPALACEPARTII from '@/components/20_chapter21menfromthepalacepartii'
 import A1_CHAPTER22TWOSMALLANDNOGUESSES from '@/components/21_chapter22twosmallandnoguesses'
 import A2_CHAPTER23SENIORSERVANTLIURETURNEDTOTHEPALACETOREPORT from '@/components/22_chapter23seniorservantliureturnedtothepalacetoreport'
 import A3_CHAPTER24ACCOMPANYINGREADINGMUSTGOTOTHEPALACE1 from '@/components/23_chapter24accompanyingreadingmustgotothepalace1'
 import A4_CHAPTER25ACCOMPANYINGREADINGMUSTGOTOTHEPALACEMEDIUM from '@/components/24_chapter25accompanyingreadingmustgotothepalacemedium'
 import A5_CHAPTER26ACCOMPANYINGTHEREADINGNEEDSTOGOTOTHEPALACEPARTII from '@/components/25_chapter26accompanyingthereadingneedstogotothepalacepartii'
 import A6_CHAPTER27PREVIOUSCHAPTERNEXTCHAPTER from '@/components/26_chapter27previouschapternextchapter'
 import A7_CHAPTER28LITTLEPARTNERINTHEPALACEMEDIUM from '@/components/27_chapter28littlepartnerinthepalacemedium'
 import A8_CHAPTER29LITTLEPARTNERINTHEPALACEPARTII from '@/components/28_chapter29littlepartnerinthepalacepartii'
 import A9_CHAPTER30LIFEINTHEPALACEPARTI from '@/components/29_chapter30lifeinthepalaceparti'
 import A0_CHAPTER31LIFEINTHEPALACEMEDIUM from '@/components/30_chapter31lifeinthepalacemedium'
 import A1_CHAPTER32LIFEINTHEPALACEPARTII from '@/components/31_chapter32lifeinthepalacepartii'
 import A2_CHAPTER33ELDESTPRINCESSASKEDABOUTVULGARITY1 from '@/components/32_chapter33eldestprincessaskedaboutvulgarity1'
 import A3_CHAPTER34ELDESTPRINCESSVENERABLEMEDIUM from '@/components/33_chapter34eldestprincessvenerablemedium'
 import A4_CHAPTER35ELDESTPRINCESSASKEDABOUTVULGARITYPARTII from '@/components/34_chapter35eldestprincessaskedaboutvulgaritypartii'
 import A5_CHAPTER36XUMINGWEIRETURNEDHOME1 from '@/components/35_chapter36xumingweireturnedhome1'
 import A6_CHAPTER37XUMINGWEIRETURNEDHOMEC from '@/components/36_chapter37xumingweireturnedhomec'
 import A7_CHAPTER38XUMINGWEIRETURNEDHOME2 from '@/components/37_chapter38xumingweireturnedhome2'
 import A8_CHAPTER39TIGERSBUTTISUNTOUCHABLE from '@/components/38_chapter39tigersbuttisuntouchable'
 import A9_CHAPTER40MOONNESTINGHOTCAULDRON1 from '@/components/39_chapter40moonnestinghotcauldron1'
 import A0_CHAPTER41MOONNESTINGHOTCAULDRONPARTII from '@/components/40_chapter41moonnestinghotcauldronpartii'
 import A1_CHAPTER42XUMINGLANTOOKOFFHERCLOTHES1 from '@/components/41_chapter42xuminglantookoffherclothes1'
 import A2_CHAPTER43XUMINGLANTOOKOFFHERCLOTHESBOTTOM from '@/components/42_chapter43xuminglantookoffherclothesbottom'
 import A3_CHAPTER44PASSENGERFUFAMILY1 from '@/components/43_chapter44passengerfufamily1'
 import A4_CHAPTER45GUESTTRAVELERFUFAMILYCHINA from '@/components/44_chapter45guesttravelerfufamilychina'
 import A5_CHAPTER46PASSENGERFUFAMILYPARTII from '@/components/45_chapter46passengerfufamilypartii'
 import A6_CHAPTER47FENGHUATINGBANQUET1 from '@/components/46_chapter47fenghuatingbanquet1'
 import A7_CHAPTER48FENGHUATINGBANQUET2 from '@/components/47_chapter48fenghuatingbanquet2'
 import A8_CHAPTER49ONTHEPAINTINGOFFENGHUATINGPARTI from '@/components/48_chapter49onthepaintingoffenghuatingparti'
 import A9_CHAPTER50ONTHEPAINTINGOFFENGHUAPAVILIONPARTII from '@/components/49_chapter50onthepaintingoffenghuapavilionpartii'
 import A0_CHAPTER51THEGAPBETWEENTHEHOMECOMINGSISTERS from '@/components/50_chapter51thegapbetweenthehomecomingsisters'
 import A1_CHAPTER52MYGOODBROTHERISSEEKINGTHEGIFTOFALARGESUMOFMONEY from '@/components/51_chapter52mygoodbrotherisseekingthegiftofalargesumofmoney'
 import A2_CHAPTER53RECKLESSMINLANINVITATION1 from '@/components/52_chapter53recklessminlaninvitation1'
 import A3_CHAPTER54RECKLESSMINLANINVITATIONPARTII from '@/components/53_chapter54recklessminlaninvitationpartii'
 import A4_CHAPTER55SUSPICIONNANNYASKINGFORMEDICINE from '@/components/54_chapter55suspicionnannyaskingformedicine'
 import A5_CHAPTER56EMBARRASSEDTSUENTSUENTSUGEISMYGUEST from '@/components/55_chapter56embarrassedtsuentsuentsugeismyguest'
 import A6_CHAPTER57ASYOUWISH1 from '@/components/56_chapter57asyouwish1'
 import A7_CHAPTER58ASYOUWISHPARTII from '@/components/57_chapter58asyouwishpartii'
 import A8_CHAPTER59BOLDPRINCESSESCAPEPALACE1 from '@/components/58_chapter59boldprincessescapepalace1'
 import A9_CHAPTER60BOLDPRINCESSESCAPEPALACE2 from '@/components/59_chapter60boldprincessescapepalace2'
 import A0_CHAPTER61ESTABLISHINGTHERULESANDREGULATIONSFORMINGWEISSERVANTSANDSERVANTS1 from '@/components/60_chapter61establishingtherulesandregulationsformingweisservantsandservants1'
 import A1_CHAPTER62RULESMINGWEIXUNSERVANTBELOW from '@/components/61_chapter62rulesmingweixunservantbelow'
 import A2_CHAPTER63HARDDAYHERREVENGEFORHISBROTHER from '@/components/62_chapter63harddayherrevengeforhisbrother'
 import A3_CHAPTER64DISCERNINGCAUSEFROMMINWEISKNOWLEDGE from '@/components/63_chapter64discerningcausefromminweisknowledge'
 import A4_CHAPTER65REUNIONOFMOTHERANDMOTHERPARTI from '@/components/64_chapter65reunionofmotherandmotherparti'
 import A5_CHAPTER66REUNIONOFMOTHERANDMOTHERPARTII from '@/components/65_chapter66reunionofmotherandmotherpartii'
 import A6_CHAPTER67COINCIDENTALLYWEMEETAGAINATSHOUSHAN1 from '@/components/66_chapter67coincidentallywemeetagainatshoushan1'
 import A7_CHAPTER68COINCIDENTALLYREUNITEDWITHSHOUSHANCHINA from '@/components/67_chapter68coincidentallyreunitedwithshoushanchina'
 import A8_CHAPTER69COINCIDENTALLYWEMEETAGAINATSHOUSHANPARTII from '@/components/68_chapter69coincidentallywemeetagainatshoushanpartii'
 import A9_CHAPTER70HOULANWASWORRIEDABOUTTHEMARRIAGE from '@/components/69_chapter70houlanwasworriedaboutthemarriage'
 import A0_CHAPTER71HESHENGCHENGUESTHOUSEYANG from '@/components/70_chapter71heshengchenguesthouseyang'
 import A1_CHAPTER72HELANGODDAUGHTERCONSCIENCE from '@/components/71_chapter72helangoddaughterconscience'
 import A2_CHAPTER73IDIOTBETROTHEDTOMARRIAGE from '@/components/72_chapter73idiotbetrothedtomarriage'
 import A3_CHAPTER74XUMINGZHUSINTENTIONTOMARRY from '@/components/73_chapter74xumingzhusintentiontomarry'
 import A4_CHAPTER75FLOWERBOARDPOEMSOFZHUDUOPARTI from '@/components/74_chapter75flowerboardpoemsofzhuduoparti'
 import A5_CHAPTER76FLOWERBOARDPOEMSBYZHUZHUDUOPARTII from '@/components/75_chapter76flowerboardpoemsbyzhuzhuduopartii'
 import A6_CHAPTER77PLOTTINGAGAINSTWANGSMARRIAGEPROPOSAL from '@/components/76_chapter77plottingagainstwangsmarriageproposal'
 import A7_CHAPTER78AGOODMISTERWRITESAGUESTLETTER from '@/components/77_chapter78agoodmisterwritesaguestletter'
 import A8_CHAPTER79MINGMEISHEARTWASFILLEDWITHJOYWHENSHESAWHERCOUSIN from '@/components/78_chapter79mingmeisheartwasfilledwithjoywhenshesawhercousin'
 import A9_CHAPTER80TREATTHENEWGUESTASAGIFTFROMMINGWEI from '@/components/79_chapter80treatthenewguestasagiftfrommingwei'
 import A0_CHAPTER81COINCIDENTALLYHEHADSCHEMEDFORFUHENGSINVITATION1 from '@/components/80_chapter81coincidentallyhehadschemedforfuhengsinvitation1'
 import A1_CHAPTER82COINCIDENTALLYHEHADSCHEMEDFORFUHENGSINVITATIONNEXT from '@/components/81_chapter82coincidentallyhehadschemedforfuhengsinvitationnext'
 import A2_CHAPTER83ADULTSFROMMENARCHETOMINGWEI from '@/components/82_chapter83adultsfrommenarchetomingwei'
 import A3_CHAPTER84GOODPLANLADYWANGTOTAKEACONCUBINE1 from '@/components/83_chapter84goodplanladywangtotakeaconcubine1'
 import A4_CHAPTER85GOODPLANLADYWANGWANTSACONCUBINE from '@/components/84_chapter85goodplanladywangwantsaconcubine'
 import A5_CHAPTER86METICULOUSQINGMEICAUSINGTROUBLE from '@/components/85_chapter86meticulousqingmeicausingtrouble'
 import A6_CHAPTER87LILITHTOMINGWEISPROMISE from '@/components/86_chapter87lilithtomingweispromise'
 import A7_CHAPTER88FINALLYTHEQUEENDIED from '@/components/87_chapter88finallythequeendied'
 import A8_CHAPTER89DIFFERENTIATINGBETWEENYANMINGWEIANDHISGOVERNMENT from '@/components/88_chapter89differentiatingbetweenyanmingweiandhisgovernment'
 import A9_CHAPTER90GOODMINWEIASAMESSENGER1 from '@/components/89_chapter90goodminweiasamessenger1'
 import A0_CHAPTER91GOODMINWEIASAMESSENGERC from '@/components/90_chapter91goodminweiasamessengerc'
 import A1_CHAPTER92GOODMINWEIASAMESSENGERPARTII from '@/components/91_chapter92goodminweiasamessengerpartii'
 import A2_CHAPTER93THECHAOSXUFUASSIGNMENT from '@/components/92_chapter93thechaosxufuassignment'
 import A3_CHAPTER94GATHERTOGETHERTOMAKEPEACE from '@/components/93_chapter94gathertogethertomakepeace'
 import A4_CHAPTER95ESCAPEANDLOVE1 from '@/components/94_chapter95escapeandlove1'
 import A5_CHAPTER96ESCAPEANDLONGEVITYRUNFORFRIENDSPARTII from '@/components/95_chapter96escapeandlongevityrunforfriendspartii'
 import A6_CHAPTER971THESTORYOFTHELOSERANDTHELOSER1 from '@/components/96_chapter971thestoryoftheloserandtheloser1'
 import A7_CHAPTER98LUOCHANGSHENGANDHISMOTHER2 from '@/components/97_chapter98luochangshengandhismother2'
 import A8_CHAPTER99SPEAKINGOFWHEREJINXICAMEFROM from '@/components/98_chapter99speakingofwherejinxicamefrom'
 import A9_CHAPTER100MYRICARUBRA from '@/components/99_chapter100myricarubra'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1directdaughtercrossingmode",
 			"name" : "0_chapter1directdaughtercrossingmode",
 			"component" : A_CHAPTER1DIRECTDAUGHTERCROSSINGMODE
 		},
 		{
 			"path" : "/1_chapter2holdagoodhandofcards",
 			"name" : "1_chapter2holdagoodhandofcards",
 			"component" : A_CHAPTER2HOLDAGOODHANDOFCARDS
 		},
 		{
 			"path" : "/2_chapter3yethehadactuallycausedhimselftocommitsuicide",
 			"name" : "2_chapter3yethehadactuallycausedhimselftocommitsuicide",
 			"component" : A_CHAPTER3YETHEHADACTUALLYCAUSEDHIMSELFTOCOMMITSUICIDE
 		},
 		{
 			"path" : "/3_chapter4myriadlovecollection",
 			"name" : "3_chapter4myriadlovecollection",
 			"component" : A_CHAPTER4MYRIADLOVECOLLECTION
 		},
 		{
 			"path" : "/4_chapter5collapseoftheconceptofmarriage",
 			"name" : "4_chapter5collapseoftheconceptofmarriage",
 			"component" : A_CHAPTER5COLLAPSEOFTHECONCEPTOFMARRIAGE
 		},
 		{
 			"path" : "/5_chapter6princessaccompanyingreading",
 			"name" : "5_chapter6princessaccompanyingreading",
 			"component" : A_CHAPTER6PRINCESSACCOMPANYINGREADING
 		},
 		{
 			"path" : "/6_chapter7astonestirsathousandripples",
 			"name" : "6_chapter7astonestirsathousandripples",
 			"component" : A_CHAPTER7ASTONESTIRSATHOUSANDRIPPLES
 		},
 		{
 			"path" : "/7_chapter8preparingforentrytothepalace",
 			"name" : "7_chapter8preparingforentrytothepalace",
 			"component" : A_CHAPTER8PREPARINGFORENTRYTOTHEPALACE
 		},
 		{
 			"path" : "/8_chapter9oldmasterxuaskedhimtoreturnhomeinadream",
 			"name" : "8_chapter9oldmasterxuaskedhimtoreturnhomeinadream",
 			"component" : A_CHAPTER9OLDMASTERXUASKEDHIMTORETURNHOMEINADREAM
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js